export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  JSONObject: any;
  Time: string;
  URL: any;
};

export enum Average_Rating {
  FourPlus = 'FOUR_PLUS',
  ThreePlus = 'THREE_PLUS'
}

export type AccorAdvantagesEligibility = {
  __typename?: 'AccorAdvantagesEligibility';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AccorMediaFormat = {
  __typename?: 'AccorMediaFormat';
  format?: Maybe<Scalars['String']>;
  generic?: Maybe<Scalars['Boolean']>;
  lastUpdate?: Maybe<Scalars['String']>;
  path: Scalars['String'];
};

export enum AccorMediaType {
  Image = 'IMAGE',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type Aggregate = {
  __typename?: 'Aggregate';
  code?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Analytic = {
  __typename?: 'Analytic';
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Datum>>>;
  description?: Maybe<Scalars['String']>;
};

export type Analytics = {
  __typename?: 'Analytics';
  analytic?: Maybe<Array<Maybe<Analytic>>>;
};

export type Anecdote = {
  __typename?: 'Anecdote';
  description?: Maybe<Scalars['String']>;
  descriptionTitle?: Maybe<Scalars['String']>;
  medias?: Maybe<Array<Maybe<RestaurantMedia>>>;
};

export type ApiRestaurant = {
  __typename?: 'ApiRestaurant';
  address?: Maybe<ApiRestaurantAddress>;
  id: Scalars['ID'];
  nameTranslations?: Maybe<Array<Maybe<TranslatedLabel>>>;
};

export type ApiRestaurantAddress = {
  __typename?: 'ApiRestaurantAddress';
  cityTranslations?: Maybe<Array<Maybe<TranslatedLabel>>>;
  countryCode?: Maybe<Scalars['String']>;
  countryTranslations?: Maybe<Array<Maybe<TranslatedLabel>>>;
};

export type AvailabilityResult = {
  __typename?: 'AvailabilityResult';
  restaurantId: Scalars['ID'];
  timeSlots?: Maybe<Array<Maybe<AvailabilitySlot>>>;
};

export type AvailabilitySlot = {
  __typename?: 'AvailabilitySlot';
  date: Scalars['String'];
  groupSize?: Maybe<Scalars['Int']>;
  isStandard?: Maybe<Scalars['Boolean']>;
  offers?: Maybe<Array<Maybe<Offer>>>;
  requireCreditCard?: Maybe<Scalars['Boolean']>;
  slot: Scalars['String'];
  standardAvailabilityFeeAmount?: Maybe<Scalars['String']>;
};

export type Award = {
  __typename?: 'Award';
  awardId?: Maybe<Scalars['String']>;
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationReason?: Maybe<Scalars['String']>;
  creationCause?: Maybe<Scalars['String']>;
  creationDate?: Maybe<Scalars['Date']>;
  expirationDate?: Maybe<Scalars['String']>;
  repaymentDetail?: Maybe<RepaymentDetail>;
  status?: Maybe<Scalars['String']>;
  stayDetail?: Maybe<StayDetail>;
  triggedDate?: Maybe<Scalars['String']>;
  updateDate?: Maybe<Scalars['Date']>;
};

export type AwardType = {
  __typename?: 'AwardType';
  IntOfAwards?: Maybe<Scalars['Int']>;
  IntOfRemainingAwards?: Maybe<Scalars['Int']>;
  awardTypeName?: Maybe<Scalars['String']>;
  awards?: Maybe<Awards>;
  nightsForNextAward?: Maybe<Scalars['Int']>;
  statusPointsForNextAward?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type AwardTypes = {
  __typename?: 'AwardTypes';
  allTypesAwardEligibility?: Maybe<Scalars['String']>;
  awardType?: Maybe<Array<Maybe<AwardType>>>;
};

export type Awards = {
  __typename?: 'Awards';
  award?: Maybe<Array<Maybe<Award>>>;
};

export type Balances = {
  __typename?: 'Balances';
  currentNightsBalance?: Maybe<Scalars['Int']>;
  currentStaysBalance?: Maybe<Scalars['Int']>;
  fastTrackedStatusNights?: Maybe<Scalars['Int']>;
  nbNightsToNextTiering?: Maybe<Scalars['Int']>;
  nbPoints?: Maybe<Scalars['Int']>;
  nbPointsEarnLast12Months?: Maybe<Scalars['Int']>;
  nbPointsToNextTiering?: Maybe<Scalars['Int']>;
  nightsSpentOnTierUpdate?: Maybe<Scalars['Int']>;
  pointsEarnedOnTierUpdate?: Maybe<Scalars['Int']>;
};

export type Booking = {
  __typename?: 'Booking';
  accountId?: Maybe<Scalars['String']>;
  bookingDate: Scalars['String'];
  bookingTime: Scalars['String'];
  depositPaidAmount?: Maybe<Scalars['Int']>;
  groupSize: Scalars['Int'];
  guest: Guest;
  id?: Maybe<Scalars['ID']>;
  paymentIntentSecret?: Maybe<Scalars['String']>;
  promotionId?: Maybe<Scalars['String']>;
  publishableKey?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type Brand = {
  __typename?: 'Brand';
  code?: Maybe<Scalars['String']>;
};

export type BrandSegment = {
  __typename?: 'BrandSegment';
  brands?: Maybe<Array<Maybe<Brand>>>;
  code?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Card = {
  __typename?: 'Card';
  beginDate?: Maybe<Scalars['String']>;
  cardInt?: Maybe<Scalars['String']>;
  cardLinks?: Maybe<CardLinks>;
  cardNumber?: Maybe<Scalars['String']>;
  cardProduct?: Maybe<CardProduct>;
  companyStampedName?: Maybe<Scalars['String']>;
  duplicationStatus?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  isLastActiveCard?: Maybe<Scalars['Boolean']>;
  isPrintable?: Maybe<Scalars['Boolean']>;
  stampedName?: Maybe<Scalars['String']>;
  statusGift?: Maybe<StatusGift>;
  temporary?: Maybe<Scalars['Boolean']>;
  termsAndConditionsAcceptanceDate?: Maybe<Scalars['String']>;
};

export type Card3 = {
  __typename?: 'Card3';
  beginDate?: Maybe<Scalars['String']>;
  cardInt?: Maybe<Scalars['String']>;
  cardProduct?: Maybe<CardProduct>;
  isLastActiveCard?: Maybe<Scalars['Boolean']>;
  isPrintable?: Maybe<Scalars['Boolean']>;
  temporary?: Maybe<Scalars['Boolean']>;
  termsAndConditionsAcceptanceDate?: Maybe<Scalars['String']>;
};

export type CardLinks = {
  __typename?: 'CardLinks';
  link?: Maybe<Array<Maybe<Link>>>;
};

export type CardProduct = {
  __typename?: 'CardProduct';
  active?: Maybe<Scalars['Boolean']>;
  cardCodeTARS?: Maybe<Scalars['String']>;
  productBin?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
  productLabel?: Maybe<Scalars['String']>;
  productTier?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
};

export type Child = {
  __typename?: 'Child';
  birthdate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  tracking?: Maybe<Tracking>;
};

export type Children = {
  __typename?: 'Children';
  child?: Maybe<Array<Maybe<Child>>>;
};

export type City = {
  __typename?: 'City';
  contentfulId?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  countrySlug?: Maybe<Scalars['String']>;
  mainTitle?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  translatedCountrySlug?: Maybe<TranslatedString>;
  translatedSlug?: Maybe<TranslatedString>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CitySuggestion = {
  __typename?: 'CitySuggestion';
  citySlug?: Maybe<Scalars['String']>;
  countrySlug?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CoBrandedCard = {
  __typename?: 'CoBrandedCard';
  cardInt?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  partnerCode?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  programmeName?: Maybe<Scalars['String']>;
  subscriptionDate?: Maybe<Scalars['String']>;
};

export type CoBrandedCards = {
  __typename?: 'CoBrandedCards';
  coBrandedCard?: Maybe<Scalars['JSONObject']>;
};

export type CobrandedRateCards = {
  __typename?: 'CobrandedRateCards';
  card?: Maybe<Array<Maybe<Card>>>;
};

export type Communication = {
  __typename?: 'Communication';
  channel?: Maybe<Scalars['String']>;
  device?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ContactMedium = {
  __typename?: 'ContactMedium';
  contextType?: Maybe<Scalars['String']>;
  emailContact?: Maybe<ContactMediumEmail>;
  id: Scalars['ID'];
  isNpai?: Maybe<Scalars['Boolean']>;
  isOptOut?: Maybe<Scalars['Boolean']>;
  mediumUsages?: Maybe<ContactMediumUsages>;
  optOutDate?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<ContactMediumPostalAddress>;
  telephoneNumber?: Maybe<ContactMediumPhoneNumber>;
  tracking?: Maybe<ContactMediumTracking>;
};

export type ContactMediumEmail = {
  __typename?: 'ContactMediumEmail';
  email?: Maybe<Scalars['String']>;
  emailRequested?: Maybe<ContactMediumEmailRequested>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export type ContactMediumEmailRequested = {
  __typename?: 'ContactMediumEmailRequested';
  email?: Maybe<Scalars['String']>;
  requesteddate?: Maybe<Scalars['String']>;
  tracking?: Maybe<ContactMediumTracking>;
};

export type ContactMediumPhoneNumber = {
  __typename?: 'ContactMediumPhoneNumber';
  isPrimary?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phonePrefix?: Maybe<Scalars['String']>;
  phoneType?: Maybe<Scalars['String']>;
};

export type ContactMediumPostalAddress = {
  __typename?: 'ContactMediumPostalAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  address4?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  intraCommunityVat?: Maybe<Scalars['String']>;
  isAsBilling?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  stateCode?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type ContactMediumTracking = {
  __typename?: 'ContactMediumTracking';
  createdByHotel?: Maybe<Scalars['String']>;
  createdByOperator?: Maybe<Scalars['String']>;
  createdBySystem?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  updatedByHotel?: Maybe<Scalars['String']>;
  updatedByOperator?: Maybe<Scalars['String']>;
  updatedBySystem?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type ContactMediumUsage = {
  __typename?: 'ContactMediumUsage';
  isOptOut?: Maybe<Scalars['Boolean']>;
  optOutDate?: Maybe<Scalars['String']>;
  usageType?: Maybe<Scalars['String']>;
};

export type ContactMediumUsages = {
  __typename?: 'ContactMediumUsages';
  mediumUsage?: Maybe<Array<ContactMediumUsage>>;
};

export type ContactMediums = {
  __typename?: 'ContactMediums';
  contactMedium?: Maybe<Array<ContactMedium>>;
};

export type Cookie = {
  __typename?: 'Cookie';
  DateAcceptation?: Maybe<Scalars['String']>;
  TypeCookie?: Maybe<Scalars['String']>;
  Version?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  tracking?: Maybe<Tracking>;
};

export type Cookies = {
  __typename?: 'Cookies';
  cookie?: Maybe<Array<Maybe<Cookie>>>;
};

export type Country = {
  __typename?: 'Country';
  code?: Maybe<Scalars['String']>;
  contentfulId?: Maybe<Scalars['String']>;
  coverMedia?: Maybe<FnBPicture>;
  doesCityExist?: Maybe<Scalars['Boolean']>;
  favoritesRestaurants?: Maybe<FavoritesRestaurants>;
  mainTitle?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nearbyRestaurants?: Maybe<RestaurantSearchResponse>;
  nearbyThematicRestaurants?: Maybe<Array<Maybe<RestaurantSearchResponse>>>;
  nearbyThematics?: Maybe<Array<Maybe<NearbyThematic>>>;
  seoItems?: Maybe<Array<Maybe<CountrySeoItem>>>;
  slug?: Maybe<Scalars['String']>;
  translatedSlug?: Maybe<TranslatedString>;
};

export type CountryBaseInformation = {
  __typename?: 'CountryBaseInformation';
  code?: Maybe<Scalars['String']>;
  contentfulId?: Maybe<Scalars['String']>;
  coverMedia?: Maybe<FnBPicture>;
  editorialTopHomepage?: Maybe<EditorialContent>;
  favoritesRestaurants?: Maybe<FavoritesRestaurants>;
  inspiration?: Maybe<Array<Maybe<EditorialContent>>>;
  mainTitle?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nearbyThematics?: Maybe<Array<Maybe<NearbyThematic>>>;
  seoItems?: Maybe<Array<Maybe<CountrySeoItem>>>;
  slug?: Maybe<Scalars['String']>;
  translatedSlug?: Maybe<TranslatedString>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type CountrySeoItem = {
  __typename?: 'CountrySeoItem';
  content?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CountrySuggestion = {
  __typename?: 'CountrySuggestion';
  countrySlug?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CriteriaBonus = {
  __typename?: 'CriteriaBonus';
  bookingBeginDate?: Maybe<Scalars['String']>;
  bookingEndDate?: Maybe<Scalars['String']>;
  minTurnOverStay?: Maybe<Scalars['String']>;
  stayBeginDate?: Maybe<Scalars['String']>;
  stayEndDate?: Maybe<Scalars['String']>;
  stayMinNights?: Maybe<Scalars['Int']>;
};

export type CustomerReview = {
  __typename?: 'CustomerReview';
  comment?: Maybe<Scalars['String']>;
  createTime?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reviewId?: Maybe<Scalars['String']>;
  reviewReply?: Maybe<GoogleLocationReviewReply>;
  reviewer?: Maybe<GoogleLocationReviewReviewer>;
  starRating?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['String']>;
};

export type Datum = {
  __typename?: 'Datum';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DiningOfferParticipation = {
  __typename?: 'DiningOfferParticipation';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export enum Editorial_Content_Variant {
  Collection = 'Collection',
  Offer = 'Offer'
}

export type EditorialContent = {
  __typename?: 'EditorialContent';
  LinkedEditorialContent?: Maybe<Array<Maybe<EditorialContent>>>;
  content?: Maybe<Scalars['String']>;
  contentfulId?: Maybe<Scalars['String']>;
  coverImage?: Maybe<FnBPicture>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  restaurants?: Maybe<Array<Maybe<Restaurant>>>;
  restaurantsCities?: Maybe<Array<Maybe<EditorialRestaurantCity>>>;
  slug?: Maybe<Scalars['String']>;
  slugs?: Maybe<EditorialContentSlugs>;
  subtitle?: Maybe<Scalars['String']>;
  termsAndConditionsDescription?: Maybe<Scalars['String']>;
  termsAndConditionsTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type EditorialContentSlugs = {
  __typename?: 'EditorialContentSlugs';
  en?: Maybe<Scalars['String']>;
  fr?: Maybe<Scalars['String']>;
};

export type EditorialRestaurantCity = {
  __typename?: 'EditorialRestaurantCity';
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type EligibilityResponse = {
  __typename?: 'EligibilityResponse';
  codeSent?: Maybe<Scalars['Boolean']>;
  contactType?: Maybe<Scalars['String']>;
};

export type ExperienceTracking = {
  __typename?: 'ExperienceTracking';
  experienceTrackingContent?: Maybe<Array<Maybe<ExperienceTrackingContent>>>;
  hotelCode?: Maybe<Scalars['String']>;
};

export type ExperienceTrackingContent = {
  __typename?: 'ExperienceTrackingContent';
  categoryCode?: Maybe<Scalars['String']>;
  checkOutDate?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  compensationCode?: Maybe<Scalars['String']>;
  courtesyPoints?: Maybe<Scalars['Int']>;
  creationDate?: Maybe<Scalars['Date']>;
  eventDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  login?: Maybe<Scalars['String']>;
  moderation?: Maybe<Moderation>;
  reasonCode?: Maybe<Scalars['String']>;
  satisfactionCode?: Maybe<Scalars['String']>;
  updateDate?: Maybe<Scalars['Date']>;
  visibility?: Maybe<Scalars['String']>;
};

export type ExperiencesTracking = {
  __typename?: 'ExperiencesTracking';
  experienceTracking?: Maybe<Array<Maybe<ExperienceTracking>>>;
};

export type ExternalSystem = {
  __typename?: 'ExternalSystem';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  systemCode?: Maybe<Scalars['String']>;
  tracking?: Maybe<Tracking>;
  updateDate?: Maybe<Scalars['Date']>;
};

export type ExternalSystems = {
  __typename?: 'ExternalSystems';
  externalSystem?: Maybe<Array<Maybe<ExternalSystem>>>;
};

export enum Filter_Type {
  FoodPreferences = 'FOOD_PREFERENCES',
  StyleOfFood = 'STYLE_OF_FOOD',
  Thematic = 'THEMATIC'
}

export type FavoriteHotel = {
  __typename?: 'FavoriteHotel';
  hotelCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tracking?: Maybe<Tracking>;
};

export type FavoriteHotels = {
  __typename?: 'FavoriteHotels';
  favoriteHotel?: Maybe<Array<Maybe<FavoriteHotel>>>;
};

export type Favorites = {
  __typename?: 'Favorites';
  hotels?: Maybe<Array<Maybe<FavoriteHotel>>>;
};

export type FavoritesRestaurants = {
  __typename?: 'FavoritesRestaurants';
  restaurants?: Maybe<Array<Maybe<Restaurant>>>;
  title?: Maybe<Scalars['String']>;
};

export type FilterResponse = {
  __typename?: 'FilterResponse';
  code?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  selected?: Maybe<Scalars['Boolean']>;
};

export type FnBPicture = {
  __typename?: 'FnBPicture';
  alt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  src?: Maybe<Scalars['String']>;
  srcSet?: Maybe<Scalars['String']>;
};

export type Footer = {
  __typename?: 'Footer';
  contentfulId?: Maybe<Scalars['String']>;
  routes?: Maybe<Array<Maybe<Route>>>;
};

export type Freenight = {
  __typename?: 'Freenight';
  checkInDate?: Maybe<Scalars['String']>;
  checkOutDate?: Maybe<Scalars['String']>;
  creationDate?: Maybe<Scalars['Date']>;
  expirationDate?: Maybe<Scalars['String']>;
  hotelCode?: Maybe<Scalars['String']>;
  hotelName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modificationDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  tarsFileInt?: Maybe<Scalars['String']>;
};

export type Freenights = {
  __typename?: 'Freenights';
  freenight?: Maybe<Array<Maybe<Freenight>>>;
};

export type GeoBox = {
  __typename?: 'GeoBox';
  bottomLeft: GeoLocationPoint;
  bottomRight: GeoLocationPoint;
  topLeft: GeoLocationPoint;
  topRight: GeoLocationPoint;
};

export type GeoCircle = {
  __typename?: 'GeoCircle';
  center: GeoLocationPoint;
  radius: Scalars['Float'];
};

export type GeoLocationPoint = {
  __typename?: 'GeoLocationPoint';
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type GeoQueryInput = {
  box?: InputMaybe<InputGeoBox>;
  center: InputGeoLocationPoint;
  radius?: InputMaybe<Scalars['Float']>;
};

export type GivenCardProduct = {
  __typename?: 'GivenCardProduct';
  active?: Maybe<Scalars['Boolean']>;
  cardCodeTARS?: Maybe<Scalars['String']>;
  productBin?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
  productLabel?: Maybe<Scalars['String']>;
  productTier?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
};

export type GoogleLocationReviewReply = {
  __typename?: 'GoogleLocationReviewReply';
  comment?: Maybe<Scalars['String']>;
  updateTime?: Maybe<Scalars['String']>;
};

export type GoogleLocationReviewReviewer = {
  __typename?: 'GoogleLocationReviewReviewer';
  displayName?: Maybe<Scalars['String']>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  profilePhotoUrl?: Maybe<Scalars['String']>;
};

export type Guest = {
  __typename?: 'Guest';
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  mobile: Scalars['String'];
  mobileCountryCode?: Maybe<Scalars['Int']>;
  postCode?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type GuestInput = {
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  mobile: Scalars['String'];
  mobileCountryCode?: InputMaybe<Scalars['Int']>;
  postCode?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Identification = {
  __typename?: 'Identification';
  clientType?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
  identificationId?: Maybe<Scalars['String']>;
  lcahmember?: Maybe<Scalars['Boolean']>;
  loyaltyCard?: Maybe<Scalars['Boolean']>;
  loyaltyMember?: Maybe<Scalars['Boolean']>;
};

export type IdentificationPlainText = {
  __typename?: 'IdentificationPlainText';
  identification?: Maybe<Identification>;
};

export type Individual = {
  __typename?: 'Individual';
  birthDate?: Maybe<Scalars['String']>;
  children?: Maybe<Children>;
  favorites?: Maybe<Favorites>;
  gender?: Maybe<Scalars['String']>;
  hasBooking?: Maybe<Scalars['Boolean']>;
  hasHotelFavorite?: Maybe<Scalars['Boolean']>;
  hasLoyaltyCard?: Maybe<Scalars['Boolean']>;
  hasPassword?: Maybe<Scalars['Boolean']>;
  hasPreference?: Maybe<Scalars['Boolean']>;
  hasSegment?: Maybe<Scalars['Boolean']>;
  hasSubscriptionCard?: Maybe<Scalars['Boolean']>;
  hasWallet?: Maybe<Scalars['Boolean']>;
  individualContracts?: Maybe<IndividualContracts>;
  individualLegalIdentifications?: Maybe<IndividualLegalIdentifications>;
  individualName?: Maybe<IndividualName>;
  individualPreferenceFamilies?: Maybe<IndividualPreferenceFamilies>;
  individualSubscriptions?: Maybe<IndividualSubscriptions>;
  isHighValueContact?: Maybe<Scalars['Boolean']>;
  isLoyaltyMember?: Maybe<Scalars['Boolean']>;
  isMerged?: Maybe<Scalars['Boolean']>;
  isReachable?: Maybe<Scalars['Boolean']>;
  isRelevant?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  mustUpdatePassword?: Maybe<Scalars['Boolean']>;
  nationality?: Maybe<Scalars['String']>;
  noShareToHotel?: Maybe<Scalars['String']>;
  optOut?: Maybe<OptOut>;
  placeOfBirth?: Maybe<Scalars['String']>;
  pmid?: Maybe<Scalars['String']>;
  registrationChannel?: Maybe<Scalars['String']>;
  tracking?: Maybe<Tracking>;
  uaUserId?: Maybe<Scalars['String']>;
  vipCode?: Maybe<Scalars['String']>;
  vipReasons?: Maybe<VipReasons>;
};

export type IndividualContracts = {
  __typename?: 'IndividualContracts';
  accessCode?: Maybe<Scalars['String']>;
  companySCCode?: Maybe<Scalars['String']>;
  contractId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  tracking?: Maybe<Tracking>;
};

export type IndividualLegalIdentification = {
  __typename?: 'IndividualLegalIdentification';
  Int?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  expirationDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  issuedDate?: Maybe<Scalars['String']>;
  issuingCountry?: Maybe<Scalars['String']>;
  issuingPlace?: Maybe<Scalars['String']>;
  nationalityCode?: Maybe<Scalars['String']>;
  tracking?: Maybe<Tracking>;
  type?: Maybe<Scalars['String']>;
  validationDate?: Maybe<Scalars['String']>;
};

export type IndividualLegalIdentifications = {
  __typename?: 'IndividualLegalIdentifications';
  individualLegalIdentification?: Maybe<Array<Maybe<IndividualLegalIdentification>>>;
};

export type IndividualName = {
  __typename?: 'IndividualName';
  civility?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
};

export type IndividualPreference = {
  __typename?: 'IndividualPreference';
  preference?: Maybe<Preference>;
  preferenceValues?: Maybe<PreferenceValues>;
};

export type IndividualPreferenceFamilies = {
  __typename?: 'IndividualPreferenceFamilies';
  individualPreferenceFamily?: Maybe<Array<Maybe<IndividualPreferenceFamily>>>;
};

export type IndividualPreferenceFamily = {
  __typename?: 'IndividualPreferenceFamily';
  code?: Maybe<Scalars['String']>;
  individualPreferences?: Maybe<IndividualPreferences>;
  preferenceFamilyLabels?: Maybe<PreferenceFamilyLabels>;
};

export type IndividualPreferences = {
  __typename?: 'IndividualPreferences';
  individualPreference?: Maybe<Array<Maybe<IndividualPreference>>>;
};

export type IndividualSubscription = {
  __typename?: 'IndividualSubscription';
  code?: Maybe<Scalars['String']>;
  communication?: Maybe<Communication>;
  id?: Maybe<Scalars['String']>;
  optin?: Maybe<Scalars['Boolean']>;
  origine?: Maybe<Scalars['String']>;
  subscribeDate?: Maybe<Scalars['String']>;
  subscriptionLabels?: Maybe<SubscriptionLabels>;
  tracking?: Maybe<Tracking>;
  unsubscribeDate?: Maybe<Scalars['String']>;
  unsubscribeReason?: Maybe<Scalars['String']>;
  unsubscriptionReasonLabels?: Maybe<UnsubscriptionReasonLabels>;
};

export type IndividualSubscriptions = {
  __typename?: 'IndividualSubscriptions';
  individualSubscription?: Maybe<Array<Maybe<IndividualSubscription>>>;
};

export type InformationBonus = {
  __typename?: 'InformationBonus';
  individualBonusType?: Maybe<Scalars['String']>;
  limitedIntOfUse?: Maybe<Scalars['String']>;
  nohetoId?: Maybe<Scalars['String']>;
  tarsKeys?: Maybe<Scalars['String']>;
  wiseId?: Maybe<Scalars['String']>;
};

export type InputGeoBox = {
  bottomLeft: InputGeoLocationPoint;
  bottomRight: InputGeoLocationPoint;
  topLeft: InputGeoLocationPoint;
  topRight: InputGeoLocationPoint;
};

export type InputGeoLocationPoint = {
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type Inspiration = {
  __typename?: 'Inspiration';
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Label = {
  __typename?: 'Label';
  label?: Maybe<Scalars['String']>;
  languageCodeAlpha2?: Maybe<Scalars['String']>;
  languageCodeAlpha3?: Maybe<Scalars['String']>;
  languageCodeISO?: Maybe<Scalars['String']>;
};

export type Lead = {
  __typename?: 'Lead';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  leadLabels?: Maybe<LeadLabels>;
  tracking?: Maybe<Tracking>;
};

export type LeadLabels = {
  __typename?: 'LeadLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type Leads = {
  __typename?: 'Leads';
  lead?: Maybe<Array<Maybe<Lead>>>;
};

export type Link = {
  __typename?: 'Link';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type LinkPartner = {
  __typename?: 'LinkPartner';
  accorAdvantagesEligibility?: Maybe<Array<Maybe<AccorAdvantagesEligibility>>>;
  isSwitchable?: Maybe<Scalars['Boolean']>;
  linkEligibile?: Maybe<Scalars['Boolean']>;
  linkEligibleDate?: Maybe<Scalars['String']>;
  partnerCode?: Maybe<Scalars['String']>;
  uneligibilityReason?: Maybe<Scalars['String']>;
};

export type Links = {
  __typename?: 'Links';
  link?: Maybe<Array<Maybe<Array<Maybe<Scalars['JSONObject']>>>>>;
};

export type Loyalty = {
  __typename?: 'Loyalty';
  awardTypes?: Maybe<AwardTypes>;
  balances?: Maybe<Balances>;
  coBrandedCards?: Maybe<CoBrandedCards>;
  cobrandedRateCards?: Maybe<CobrandedRateCards>;
  freenights?: Maybe<Freenights>;
  linkPartners?: Maybe<Array<Maybe<LinkPartner>>>;
  links?: Maybe<Links>;
  loyaltyCards?: Maybe<LoyaltyCards>;
  memberInfo?: Maybe<MemberInfo>;
  operations?: Maybe<Operations>;
  subscribedBonuses?: Maybe<SubscribedBonuses>;
  subscriptionCards?: Maybe<SubscriptionCards>;
};

export type LoyaltyBanner = {
  __typename?: 'LoyaltyBanner';
  contentfulId?: Maybe<Scalars['String']>;
  ctaLabel?: Maybe<Scalars['String']>;
  ctaUrl?: Maybe<Scalars['String']>;
  program?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userStatus?: Maybe<Scalars['String']>;
  usp?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type LoyaltyCards = {
  __typename?: 'LoyaltyCards';
  card?: Maybe<Array<Maybe<Card>>>;
  statusGiftEligibility?: Maybe<Scalars['String']>;
};

export type MemberInfo = {
  __typename?: 'MemberInfo';
  allTypesAwardEligibility?: Maybe<Scalars['String']>;
  displayBurnOnline?: Maybe<Scalars['Boolean']>;
  enrollCompletionReminderEmailSent?: Maybe<Scalars['Boolean']>;
  enrolledBeforeGDPRCompliancy?: Maybe<Scalars['Boolean']>;
  fullEnrolmentDate?: Maybe<Scalars['String']>;
  locked?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  loyaltyTermsAndConditionsAcceptancedate?: Maybe<Scalars['String']>;
  meetingPlannerAuthorizationEnddate?: Maybe<Scalars['String']>;
  memberPhysicalCard?: Maybe<Scalars['Boolean']>;
  nextTiering?: Maybe<Scalars['String']>;
  pointsExpirationdate?: Maybe<Scalars['String']>;
  preEnrollExpirationDate?: Maybe<Scalars['String']>;
  qrCode?: Maybe<Scalars['JSONObject']>;
  status?: Maybe<Scalars['String']>;
  userHashKey?: Maybe<Scalars['String']>;
};

export enum MenuType {
  Api = 'API',
  External = 'EXTERNAL',
  MenuModo = 'MENU_MODO'
}

export type Moderated = {
  __typename?: 'Moderated';
  category?: Maybe<Scalars['String']>;
  subCategory?: Maybe<Scalars['String']>;
  word?: Maybe<Scalars['String']>;
};

export type Moderation = {
  __typename?: 'Moderation';
  moderated?: Maybe<Array<Maybe<Moderated>>>;
  originalComment?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  bookTable?: Maybe<Booking>;
  bookingPaiement?: Maybe<Booking>;
};


export type MutationBookTableArgs = {
  bookingDate: Scalars['String'];
  bookingTime: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  groupSize: Scalars['Int'];
  guest: GuestInput;
  promotionId?: InputMaybe<Scalars['String']>;
  restaurantId: Scalars['ID'];
};


export type MutationBookingPaiementArgs = {
  bookingDate: Scalars['String'];
  bookingReference: Scalars['String'];
  bookingTime: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  groupSize: Scalars['Int'];
  guest: GuestInput;
  payment?: InputMaybe<Payment>;
  paymentToken?: InputMaybe<Scalars['String']>;
  promotionId?: InputMaybe<Scalars['String']>;
  restaurantId: Scalars['ID'];
};

export type NbNightsByProduct = {
  __typename?: 'NbNightsByProduct';
  multiplyingPointsCoeff?: Maybe<Scalars['String']>;
  nbNights?: Maybe<Scalars['Int']>;
  nbPointsStay1?: Maybe<Scalars['Int']>;
  nbPointsStay2?: Maybe<Scalars['Int']>;
  nbPointsStay3?: Maybe<Scalars['Int']>;
  nbPointsStay4?: Maybe<Scalars['Int']>;
  nightsForAProduct?: Maybe<Array<Maybe<NightsForAProduct>>>;
};

export type NearbyThematic = {
  __typename?: 'NearbyThematic';
  thematic?: Maybe<Thematic>;
  title?: Maybe<Scalars['String']>;
};

export type NightsForAProduct = {
  __typename?: 'NightsForAProduct';
  productCode?: Maybe<Scalars['Int']>;
  productLabel?: Maybe<Scalars['String']>;
};

/** An object with an ID. */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID'];
};

export enum Offer_And_Loyalty {
  Loyalty = 'LOYALTY',
  Offer = 'OFFER'
}

export type Offer = {
  __typename?: 'Offer';
  feeAmount?: Maybe<Scalars['String']>;
  groupSize?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type OpeningHour = {
  __typename?: 'OpeningHour';
  from: Scalars['String'];
  to: Scalars['String'];
};

export type Operations = {
  __typename?: 'Operations';
  maxResultOperationsExceeded?: Maybe<Scalars['Boolean']>;
  operation?: Maybe<Array<Maybe<UserOperation>>>;
};

export type OptOut = {
  __typename?: 'OptOut';
  isOptOutTotal?: Maybe<Scalars['Boolean']>;
  optOutDate?: Maybe<Scalars['String']>;
};

export type Payment = {
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
};

export type Period = {
  __typename?: 'Period';
  from?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['DateTime']>;
};

export type PersonalizedPage = {
  __typename?: 'PersonalizedPage';
  content?: Maybe<Scalars['String']>;
  contentfulId?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  translatedSlug?: Maybe<TranslatedString>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type PoiSuggestion = {
  __typename?: 'PoiSuggestion';
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Preference = {
  __typename?: 'Preference';
  code?: Maybe<Scalars['String']>;
  defaultName?: Maybe<Scalars['String']>;
  preferenceLabels?: Maybe<PreferenceLabels>;
  valuesType?: Maybe<Scalars['String']>;
};

export type PreferenceFamilyLabels = {
  __typename?: 'PreferenceFamilyLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type PreferenceLabels = {
  __typename?: 'PreferenceLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type PreferenceValue = {
  __typename?: 'PreferenceValue';
  brandSegment?: Maybe<BrandSegment>;
  code?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  commentLanguage?: Maybe<Scalars['String']>;
  commentTitle?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['String']>;
  createdByHotel?: Maybe<Scalars['String']>;
  defaultName?: Maybe<Scalars['String']>;
  favoriteCentral?: Maybe<Scalars['Boolean']>;
  favoriteClient?: Maybe<Scalars['Boolean']>;
  favoriteHotels?: Maybe<FavoriteHotels>;
  id?: Maybe<Scalars['String']>;
  moderation?: Maybe<Moderation>;
  nature?: Maybe<Scalars['String']>;
  optinDate?: Maybe<Scalars['String']>;
  preferenceValueLabels?: Maybe<PreferenceValueLabels>;
  sensitive?: Maybe<Scalars['Boolean']>;
  tracking?: Maybe<Tracking>;
  updated?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type PreferenceValueLabels = {
  __typename?: 'PreferenceValueLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type PreferenceValues = {
  __typename?: 'PreferenceValues';
  preferenceValue?: Maybe<Array<Maybe<PreferenceValue>>>;
};

export type PromiseBonus = {
  __typename?: 'PromiseBonus';
  nbNightsByProduct?: Maybe<NbNightsByProduct>;
  nbPoints?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  accountEligibility?: Maybe<EligibilityResponse>;
  booking?: Maybe<Booking>;
  citiesByCountrySlug?: Maybe<Array<Maybe<City>>>;
  city?: Maybe<City>;
  countries?: Maybe<Array<Maybe<Country>>>;
  countryBaseInformation?: Maybe<CountryBaseInformation>;
  countryBySlug?: Maybe<Country>;
  editorialContent?: Maybe<EditorialContent>;
  footer?: Maybe<Footer>;
  getSuggestions?: Maybe<Array<Maybe<Suggestion>>>;
  identificationPlainText?: Maybe<IdentificationPlainText>;
  inspiration?: Maybe<Inspiration>;
  loyaltyBanner?: Maybe<Array<Maybe<LoyaltyBanner>>>;
  multipleAvailabilities?: Maybe<Array<Maybe<AvailabilityResult>>>;
  nextAvailability?: Maybe<AvailabilitySlot>;
  now: Scalars['DateTime'];
  personalizedPage?: Maybe<PersonalizedPage>;
  restaurant?: Maybe<Restaurant>;
  restaurantFromWc?: Maybe<ApiRestaurant>;
  restaurantReviews?: Maybe<RestaurantReview>;
  restaurants?: Maybe<RestaurantSearchResponse>;
  restaurantsByGeo?: Maybe<RestaurantSearchResponse>;
  restaurantsByQuery?: Maybe<RestaurantSearchResponse>;
  searchEditorialContent?: Maybe<SearchEditorialContentResultType>;
  searchRestaurants?: Maybe<RestaurantSearchResponse>;
  singleAvailabilities?: Maybe<Array<Maybe<AvailabilitySlot>>>;
  sitemap?: Maybe<Sitemap>;
  verifyCode?: Maybe<VerifyCodeResponse>;
};


export type QueryAccountEligibilityArgs = {
  email?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
};


export type QueryBookingArgs = {
  bookingReference: Scalars['ID'];
  restaurantId: Scalars['ID'];
};


export type QueryCitiesByCountrySlugArgs = {
  countrySlug?: InputMaybe<Scalars['String']>;
};


export type QueryCityArgs = {
  citySlug?: InputMaybe<Scalars['String']>;
  countrySlug?: InputMaybe<Scalars['String']>;
};


export type QueryCountryBaseInformationArgs = {
  fallBack?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
};


export type QueryCountryBySlugArgs = {
  date?: InputMaybe<Scalars['String']>;
  groupSize?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  userCity: Scalars['String'];
  userCountry: Scalars['String'];
};


export type QueryEditorialContentArgs = {
  filteredCities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug: Scalars['String'];
  type: Scalars['String'];
};


export type QueryGetSuggestionsArgs = {
  search: Scalars['String'];
};


export type QueryIdentificationPlainTextArgs = {
  accessCode?: InputMaybe<Scalars['String']>;
  cardNumber?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  preferentialCode?: InputMaybe<Scalars['String']>;
};


export type QueryLoyaltyBannerArgs = {
  type: Scalars['String'];
};


export type QueryMultipleAvailabilitiesArgs = {
  from: Scalars['String'];
  groupSize: Scalars['Int'];
  ids: Array<Scalars['ID']>;
  realTime: Scalars['Boolean'];
};


export type QueryNextAvailabilityArgs = {
  from?: InputMaybe<Scalars['String']>;
  groupSize?: InputMaybe<Scalars['Int']>;
  maxGuests?: InputMaybe<Scalars['Int']>;
  minGuests?: InputMaybe<Scalars['Int']>;
  offerId?: InputMaybe<Scalars['String']>;
  restaurantId: Scalars['ID'];
  validityPeriods?: InputMaybe<Array<InputMaybe<RestaurantOffersValidityInput>>>;
};


export type QueryPersonalizedPageArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryRestaurantArgs = {
  id: Scalars['ID'];
};


export type QueryRestaurantFromWcArgs = {
  id: Scalars['ID'];
};


export type QueryRestaurantReviewsArgs = {
  restaurantId: Scalars['ID'];
};


export type QueryRestaurantsArgs = {
  query: Scalars['String'];
};


export type QueryRestaurantsByGeoArgs = {
  box?: InputMaybe<InputGeoBox>;
  center: InputGeoLocationPoint;
  radius?: InputMaybe<Scalars['Float']>;
};


export type QueryRestaurantsByQueryArgs = {
  city: Scalars['String'];
  country: Scalars['String'];
};


export type QuerySearchEditorialContentArgs = {
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  variant?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySearchRestaurantsArgs = {
  citySlug?: InputMaybe<Scalars['String']>;
  countrySlug?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  geoQuery?: InputMaybe<GeoQueryInput>;
  groupSize?: InputMaybe<Scalars['Int']>;
  poiQuery?: InputMaybe<Scalars['String']>;
  searchFilters?: InputMaybe<SearchFilterInput>;
};


export type QuerySingleAvailabilitiesArgs = {
  from: Scalars['String'];
  groupSize: Scalars['Int'];
  id: Scalars['ID'];
  realTime: Scalars['Boolean'];
  to?: InputMaybe<Scalars['String']>;
};


export type QueryVerifyCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
};

export type QuestionAnswer = {
  __typename?: 'QuestionAnswer';
  answer?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type RepaymentDetail = {
  __typename?: 'RepaymentDetail';
  amountInCurrency?: Maybe<Scalars['Int']>;
  amountInEuro?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  nbDecimalsCurrency?: Maybe<Scalars['Int']>;
  refundDate?: Maybe<Scalars['Date']>;
  refundRate?: Maybe<Scalars['Int']>;
};

export type Restaurant = {
  __typename?: 'Restaurant';
  accommodateMealCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  accommodateMeals?: Maybe<Array<Maybe<Scalars['String']>>>;
  advantages?: Maybe<Array<Maybe<Scalars['String']>>>;
  amenities?: Maybe<Array<Maybe<Scalars['String']>>>;
  amenityCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  anecdote?: Maybe<Anecdote>;
  availabilities?: Maybe<Array<Maybe<AvailabilitySlot>>>;
  averagePrice?: Maybe<Scalars['Float']>;
  averageRating?: Maybe<Scalars['Float']>;
  bookingWidgetUrl?: Maybe<Scalars['String']>;
  brandCode?: Maybe<Scalars['String']>;
  brunchInsert?: Maybe<RestaurantBrunchInsert>;
  carParks?: Maybe<Scalars['String']>;
  catchPhrase?: Maybe<Scalars['String']>;
  chef?: Maybe<RestaurantChef>;
  city?: Maybe<Scalars['String']>;
  cityMainTitle?: Maybe<Scalars['String']>;
  citySlug?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  contentfulId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  countrySlug?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  currencySymbol?: Maybe<Scalars['String']>;
  defaultFoodType?: Maybe<Scalars['String']>;
  enrolmentPrograms?: Maybe<RestaurantEnrolmentPrograms>;
  exceptionalClosures?: Maybe<Array<Maybe<Period>>>;
  externalMenuUrl?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  facetCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  facets?: Maybe<Array<Maybe<Scalars['String']>>>;
  foodType?: Maybe<Scalars['String']>;
  foodTypeCode?: Maybe<Scalars['String']>;
  hotelCode?: Maybe<Scalars['String']>;
  hotelName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifiers?: Maybe<Array<Maybe<RestaurantIdentifier>>>;
  imageUrl?: Maybe<Scalars['URL']>;
  instagram?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  logoUrl?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['Float']>;
  mail?: Maybe<Scalars['String']>;
  mainTitle?: Maybe<Scalars['String']>;
  medias?: Maybe<Array<Maybe<RestaurantMedia>>>;
  menuType?: Maybe<MenuType>;
  menus?: Maybe<Array<Maybe<RestaurantMenu>>>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameTranslations?: Maybe<Array<Maybe<TranslatedLabel>>>;
  nearByRestaurants?: Maybe<Array<Maybe<Restaurant>>>;
  offers?: Maybe<Array<Maybe<RestaurantOffers>>>;
  particularity?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['String']>;
  paymentMeanCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  paymentMeans?: Maybe<Array<Maybe<Scalars['String']>>>;
  phone?: Maybe<Scalars['String']>;
  phonePrefix?: Maybe<Scalars['String']>;
  reviewCount?: Maybe<Scalars['Int']>;
  schedule?: Maybe<Array<Maybe<ScheduleOpenedDay>>>;
  serviceCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  services?: Maybe<Array<Maybe<Scalars['String']>>>;
  star?: Maybe<Scalars['Int']>;
  street?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  timezoneId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  veryLongDescriptionPart1?: Maybe<Scalars['String']>;
  veryLongDescriptionPart2?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  zone?: Maybe<Scalars['String']>;
};

export type RestaurantBrunchInsert = {
  __typename?: 'RestaurantBrunchInsert';
  brunchFeatures: Array<Scalars['String']>;
  days: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  period?: Maybe<RestaurantBrunchPeriod>;
  title?: Maybe<Scalars['String']>;
};

export type RestaurantBrunchPeriod = {
  __typename?: 'RestaurantBrunchPeriod';
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type RestaurantChef = {
  __typename?: 'RestaurantChef';
  description?: Maybe<Scalars['String']>;
  descriptionTitle?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  medias?: Maybe<Array<Maybe<RestaurantMedia>>>;
  name?: Maybe<Scalars['String']>;
};

export type RestaurantEnrolmentPrograms = {
  __typename?: 'RestaurantEnrolmentPrograms';
  availablePrograms?: Maybe<Array<Maybe<Scalars['String']>>>;
  diningOfferParticipation?: Maybe<DiningOfferParticipation>;
};

export type RestaurantIdentifier = {
  __typename?: 'RestaurantIdentifier';
  micrositeName?: Maybe<Scalars['String']>;
  system?: Maybe<System_Type>;
};

export type RestaurantMedia = {
  __typename?: 'RestaurantMedia';
  formats?: Maybe<Array<Maybe<AccorMediaFormat>>>;
  type?: Maybe<AccorMediaType>;
};

export type RestaurantMenu = {
  __typename?: 'RestaurantMenu';
  language?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  storageUrl?: Maybe<Scalars['String']>;
  urlName?: Maybe<Scalars['String']>;
};

export type RestaurantOffers = {
  __typename?: 'RestaurantOffers';
  chargeAmount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  images?: Maybe<RestaurantOffersImage>;
  isAccorPlus?: Maybe<Scalars['Boolean']>;
  maxGuests?: Maybe<Scalars['Int']>;
  minGuests?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  requireCreditCard?: Maybe<Scalars['Boolean']>;
  requireDeposit?: Maybe<Scalars['Boolean']>;
  validityPeriods?: Maybe<Array<Maybe<RestaurantOffersValidity>>>;
};

export type RestaurantOffersImage = {
  __typename?: 'RestaurantOffersImage';
  desktopImage?: Maybe<FnBPicture>;
  mobileImage?: Maybe<FnBPicture>;
};

export type RestaurantOffersValidity = {
  __typename?: 'RestaurantOffersValidity';
  endDate?: Maybe<Scalars['String']>;
  frequency?: Maybe<Array<Maybe<Schedule_Days>>>;
  startDate?: Maybe<Scalars['String']>;
};

export type RestaurantOffersValidityInput = {
  endDate?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Array<InputMaybe<Schedule_Days>>>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type RestaurantReview = {
  __typename?: 'RestaurantReview';
  restaurantCode: Scalars['ID'];
  reviews?: Maybe<Array<Maybe<CustomerReview>>>;
};

export type RestaurantSearchResponse = {
  __typename?: 'RestaurantSearchResponse';
  box?: Maybe<GeoBox>;
  center: GeoLocationPoint;
  filters?: Maybe<SearchFilterResponse>;
  radius?: Maybe<Scalars['Float']>;
  results?: Maybe<Array<Maybe<Restaurant>>>;
  statistics?: Maybe<RestaurantSearchStats>;
  thematic?: Maybe<RestaurantSearchThematic>;
};

export type RestaurantSearchStats = {
  __typename?: 'RestaurantSearchStats';
  count?: Maybe<Scalars['Int']>;
};

export type RestaurantSearchThematic = {
  __typename?: 'RestaurantSearchThematic';
  code?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Thematic_Type>;
};

export type RestaurantSuggestion = {
  __typename?: 'RestaurantSuggestion';
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  facet?: Maybe<Scalars['String']>;
  foodType?: Maybe<Scalars['String']>;
  identifiers?: Maybe<RestaurantIdentifier>;
  media?: Maybe<RestaurantMedia>;
  restaurantCode?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Route = {
  __typename?: 'Route';
  externalUrl?: Maybe<Scalars['String']>;
  internalPageSlug?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export enum Schedule_Days {
  BankHolidays = 'BANK_HOLIDAYS',
  Everyday = 'EVERYDAY',
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Weekend = 'WEEKEND',
  WeekendsAndBankHolidays = 'WEEKENDS_AND_BANK_HOLIDAYS'
}

export enum System_Type {
  Opentable = 'OPENTABLE',
  Resdiary = 'RESDIARY',
  Sevenrooms = 'SEVENROOMS',
  Tars = 'TARS',
  Zenchef = 'ZENCHEF'
}

export type ScheduleOpenedDay = {
  __typename?: 'ScheduleOpenedDay';
  day: Schedule_Days;
  openingHours?: Maybe<Array<Maybe<OpeningHour>>>;
};

export type SearchEditorialContentResultType = {
  __typename?: 'SearchEditorialContentResultType';
  currentPage?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['Int']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  lastEditorialContent?: Maybe<EditorialContent>;
  results?: Maybe<Array<Maybe<EditorialContent>>>;
  size?: Maybe<Scalars['Int']>;
  totalPage?: Maybe<Scalars['Int']>;
};

export type SearchFilterInput = {
  AVERAGE_RATING?: InputMaybe<Array<Average_Rating>>;
  FOOD_PREFERENCES?: InputMaybe<Array<Scalars['String']>>;
  OFFER_AND_LOYALTY?: InputMaybe<Array<Offer_And_Loyalty>>;
  STYLE_OF_FOOD?: InputMaybe<Array<Scalars['String']>>;
  THEMATIC?: InputMaybe<Array<Scalars['String']>>;
  available?: InputMaybe<Scalars['Boolean']>;
  hotelCluster?: InputMaybe<Scalars['Boolean']>;
  includeFilters: Scalars['Boolean'];
  maxPrice?: InputMaybe<Scalars['Int']>;
  minPrice?: InputMaybe<Scalars['Int']>;
};

export type SearchFilterResponse = {
  __typename?: 'SearchFilterResponse';
  AVERAGE_RATING?: Maybe<Array<Maybe<FilterResponse>>>;
  FOOD_PREFERENCES?: Maybe<Array<Maybe<FilterResponse>>>;
  OFFER_AND_LOYALTY?: Maybe<Array<Maybe<FilterResponse>>>;
  STYLE_OF_FOOD?: Maybe<Array<Maybe<FilterResponse>>>;
  THEMATIC?: Maybe<Array<Maybe<FilterResponse>>>;
  available?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  globalMaxPrice?: Maybe<Scalars['Int']>;
  globalMinPrice?: Maybe<Scalars['Int']>;
  userMaxPrice?: Maybe<Scalars['Int']>;
  userMinPrice?: Maybe<Scalars['Int']>;
};

export type Sitemap = {
  __typename?: 'Sitemap';
  cities?: Maybe<Array<Maybe<City>>>;
  countries?: Maybe<Array<Maybe<CountryBaseInformation>>>;
  editorialContents?: Maybe<Array<Maybe<EditorialContent>>>;
  inspiration?: Maybe<Inspiration>;
  personalizedPages?: Maybe<Array<Maybe<PersonalizedPage>>>;
  restaurants?: Maybe<Array<Maybe<Restaurant>>>;
};

export type StatusGift = {
  __typename?: 'StatusGift';
  beneficiaryCardInt?: Maybe<Scalars['String']>;
  beneficiaryPmid?: Maybe<Scalars['String']>;
  beneficiaryStatusExpirationDate?: Maybe<Scalars['String']>;
  giftExpirationDate?: Maybe<Scalars['String']>;
  givenCardProduct?: Maybe<GivenCardProduct>;
  statusGiftDate?: Maybe<Scalars['String']>;
};

export type StayDetail = {
  __typename?: 'StayDetail';
  bookingValueDate?: Maybe<Scalars['String']>;
  checkInDate?: Maybe<Scalars['String']>;
  checkOutDate?: Maybe<Scalars['String']>;
  hotelCode?: Maybe<Scalars['String']>;
  hotelName?: Maybe<Scalars['String']>;
  redeemedLoginHL?: Maybe<Scalars['String']>;
  redemptionDate?: Maybe<Scalars['String']>;
  roomInt?: Maybe<Scalars['String']>;
  tarsBookingInt?: Maybe<Scalars['String']>;
  tarsFileInt?: Maybe<Scalars['String']>;
};

export type SubscribedBonus = {
  __typename?: 'SubscribedBonus';
  code?: Maybe<Scalars['String']>;
  criteriaBonus?: Maybe<CriteriaBonus>;
  enrollmentDate?: Maybe<Scalars['String']>;
  informationBonus?: Maybe<InformationBonus>;
  name?: Maybe<Scalars['String']>;
  promiseBonus?: Maybe<PromiseBonus>;
  type?: Maybe<Scalars['String']>;
};

export type SubscribedBonuses = {
  __typename?: 'SubscribedBonuses';
  subscribedBonus?: Maybe<Array<Maybe<SubscribedBonus>>>;
};

export type SubscriptionCards = {
  __typename?: 'SubscriptionCards';
  card?: Maybe<Array<Maybe<Card>>>;
  statusGiftEligibility?: Maybe<Scalars['String']>;
};

export type SubscriptionLabels = {
  __typename?: 'SubscriptionLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type Suggestion = CitySuggestion | CountrySuggestion | PoiSuggestion | RestaurantSuggestion;

export type Survey = {
  __typename?: 'Survey';
  aggregates?: Maybe<Array<Maybe<Aggregate>>>;
  file?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  questionAnswers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  stayDetail?: Maybe<StayDetail>;
};

export type Surveys = {
  __typename?: 'Surveys';
  aggregates?: Maybe<Array<Maybe<Aggregate>>>;
  survey?: Maybe<Array<Maybe<Survey>>>;
};

export enum Thematic_Type {
  FoodPreferences = 'FOOD_PREFERENCES',
  StyleOfFood = 'STYLE_OF_FOOD',
  Thematic = 'THEMATIC'
}

export type Thematic = {
  __typename?: 'Thematic';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Thematic_Type>;
};

export type Tracking = {
  __typename?: 'Tracking';
  createdByHotel?: Maybe<Scalars['String']>;
  createdByOperator?: Maybe<Scalars['String']>;
  createdBySystem?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['Date']>;
  updatedByHotel?: Maybe<Scalars['String']>;
  updatedByOperator?: Maybe<Scalars['String']>;
  updatedBySystem?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['Date']>;
};

export type TranslatedLabel = {
  __typename?: 'TranslatedLabel';
  label?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type TranslatedString = {
  __typename?: 'TranslatedString';
  en?: Maybe<Scalars['String']>;
  fr?: Maybe<Scalars['String']>;
};

export type UnsubscriptionReasonLabels = {
  __typename?: 'UnsubscriptionReasonLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type UserOperation = {
  __typename?: 'UserOperation';
  cancelled?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  fileInt?: Maybe<Scalars['String']>;
  nightsCount?: Maybe<Scalars['Int']>;
  offerCode?: Maybe<Scalars['String']>;
  offerName?: Maybe<Scalars['String']>;
  operationDate?: Maybe<Scalars['Date']>;
  points?: Maybe<Scalars['Int']>;
  statusPoints?: Maybe<Scalars['Int']>;
  transactionDate?: Maybe<Scalars['Date']>;
  type?: Maybe<Scalars['String']>;
};

export type VerifyCodeResponse = {
  __typename?: 'VerifyCodeResponse';
  acknowledge?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
};

export type VipReason = {
  __typename?: 'VipReason';
  code?: Maybe<Scalars['String']>;
  createdByHotelCode?: Maybe<Scalars['String']>;
  creationDate?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['String']>;
  tracking?: Maybe<Tracking>;
  updatedate?: Maybe<Scalars['Date']>;
  vipReasonHotelLikes?: Maybe<VipReasonHotelLikes>;
  vipReasonLabels?: Maybe<VipReasonLabels>;
};

export type VipReasonHotelLike = {
  __typename?: 'VipReasonHotelLike';
  hotelCode?: Maybe<Scalars['String']>;
  tracking?: Maybe<Tracking>;
};

export type VipReasonHotelLikes = {
  __typename?: 'VipReasonHotelLikes';
  vipReasonHotelLike?: Maybe<Array<Maybe<VipReasonHotelLike>>>;
};

export type VipReasonLabels = {
  __typename?: 'VipReasonLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type VipReasons = {
  __typename?: 'VipReasons';
  vipReason?: Maybe<Array<Maybe<VipReason>>>;
};

export type Wallet = {
  __typename?: 'Wallet';
  creationDate?: Maybe<Scalars['Date']>;
  endUse?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startUse?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updateDate?: Maybe<Scalars['Date']>;
};

export type Wallets = {
  __typename?: 'Wallets';
  wallet?: Maybe<Array<Maybe<Wallet>>>;
};

export type AvailabilitySlotFragmentFragment = { __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null };

export type CardEditorialFragment = { __typename?: 'EditorialContent', contentfulId?: string | null, subtitle?: string | null, title?: string | null, variant?: string | null, coverImage?: { __typename?: 'FnBPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, slugs?: { __typename?: 'EditorialContentSlugs', en?: string | null, fr?: string | null } | null };

export type CustomerReviewFragment = { __typename: 'CustomerReview', comment?: string | null, createTime?: string | null, name?: string | null, reviewId?: string | null, starRating?: string | null, reviewer?: { __typename?: 'GoogleLocationReviewReviewer', displayName?: string | null, isAnonymous?: boolean | null, profilePhotoUrl?: string | null } | null, reviewReply?: { __typename?: 'GoogleLocationReviewReply', comment?: string | null, updateTime?: string | null } | null };

export type RestaurantFragment = { __typename?: 'Restaurant', accommodateMealCodes?: Array<string | null> | null, accommodateMeals?: Array<string | null> | null, amenities?: Array<string | null> | null, amenityCodes?: Array<string | null> | null, averagePrice?: number | null, averageRating?: number | null, bookingWidgetUrl?: string | null, brandCode?: string | null, city?: string | null, cityMainTitle?: string | null, citySlug?: string | null, code?: string | null, contentfulId?: string | null, country?: string | null, countryCode?: string | null, countrySlug?: string | null, currency?: string | null, currencySymbol?: string | null, defaultFoodType?: string | null, externalMenuUrl?: string | null, facetCodes?: Array<string | null> | null, facebook?: string | null, facets?: Array<string | null> | null, foodTypeCode?: string | null, foodType?: string | null, hotelName?: string | null, hotelCode?: string | null, id: string, imageUrl?: any | null, instagram?: string | null, lat?: number | null, logoUrl?: string | null, lon?: number | null, mainTitle?: string | null, mail?: string | null, menuType?: MenuType | null, metaDescription?: string | null, metaTitle?: string | null, name?: string | null, partnerId?: string | null, paymentMeanCodes?: Array<string | null> | null, paymentMeans?: Array<string | null> | null, phone?: string | null, phonePrefix?: string | null, reviewCount?: number | null, serviceCodes?: Array<string | null> | null, services?: Array<string | null> | null, star?: number | null, street?: string | null, termsAndConditions?: string | null, updatedAt?: string | null, timezoneId?: string | null, zipCode?: string | null, zone?: string | null, availabilities?: Array<{ __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null } | null> | null, exceptionalClosures?: Array<{ __typename?: 'Period', from?: string | null, to?: string | null } | null> | null, enrolmentPrograms?: { __typename?: 'RestaurantEnrolmentPrograms', availablePrograms?: Array<string | null> | null, diningOfferParticipation?: { __typename?: 'DiningOfferParticipation', code?: string | null, description?: string | null } | null } | null, identifiers?: Array<{ __typename?: 'RestaurantIdentifier', micrositeName?: string | null, system?: System_Type | null } | null> | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null } | null> | null, menus?: Array<{ __typename?: 'RestaurantMenu', urlName?: string | null, storageUrl?: string | null, language?: string | null, name?: string | null } | null> | null, offers?: Array<{ __typename?: 'RestaurantOffers', id?: string | null, name?: string | null, description?: string | null, isAccorPlus?: boolean | null, price?: number | null, minGuests?: number | null, maxGuests?: number | null, chargeAmount?: number | null, requireDeposit?: boolean | null, requireCreditCard?: boolean | null, images?: { __typename?: 'RestaurantOffersImage', desktopImage?: { __typename?: 'FnBPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, mobileImage?: { __typename?: 'FnBPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null } | null, validityPeriods?: Array<{ __typename?: 'RestaurantOffersValidity', endDate?: string | null, frequency?: Array<Schedule_Days | null> | null, startDate?: string | null } | null> | null } | null> | null, nameTranslations?: Array<{ __typename?: 'TranslatedLabel', label?: string | null, language?: string | null } | null> | null, schedule?: Array<{ __typename?: 'ScheduleOpenedDay', day: Schedule_Days, openingHours?: Array<{ __typename?: 'OpeningHour', from: string, to: string } | null> | null } | null> | null };

export type RestaurantCardFragment = { __typename?: 'Restaurant', averagePrice?: number | null, averageRating?: number | null, bookingWidgetUrl?: string | null, currency?: string | null, facetCodes?: Array<string | null> | null, foodType?: string | null, id: string, city?: string | null, imageUrl?: any | null, hotelCode?: string | null, lat?: number | null, lon?: number | null, partnerId?: string | null, phone?: string | null, phonePrefix?: string | null, name?: string | null, star?: number | null, reviewCount?: number | null, zipCode?: string | null, availabilities?: Array<{ __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null } | null> | null, identifiers?: Array<{ __typename?: 'RestaurantIdentifier', micrositeName?: string | null, system?: System_Type | null } | null> | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null } | null> | null, enrolmentPrograms?: { __typename?: 'RestaurantEnrolmentPrograms', availablePrograms?: Array<string | null> | null, diningOfferParticipation?: { __typename?: 'DiningOfferParticipation', code?: string | null, description?: string | null } | null } | null };

export type TranslatableFieldFragmentFragment = { __typename?: 'TranslatedString', en?: string | null, fr?: string | null };

export type BookTableMutationVariables = Exact<{
  restaurantId: Scalars['ID'];
  groupSize: Scalars['Int'];
  bookingDate: Scalars['String'];
  bookingTime: Scalars['String'];
  guest: GuestInput;
  promotionId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
}>;


export type BookTableMutation = { __typename?: 'Mutation', bookTable?: { __typename?: 'Booking', id?: string | null, status: string, publishableKey?: string | null, accountId?: string | null, paymentIntentSecret?: string | null, depositPaidAmount?: number | null, groupSize: number, bookingDate: string, bookingTime: string, promotionId?: string | null, guest: { __typename?: 'Guest', firstname: string, lastname: string, title?: string | null, mobile: string, mobileCountryCode?: number | null, email: string, postCode?: string | null } } | null };

export type BookingPaiementMutationVariables = Exact<{
  restaurantId: Scalars['ID'];
  bookingReference: Scalars['String'];
  groupSize: Scalars['Int'];
  bookingDate: Scalars['String'];
  bookingTime: Scalars['String'];
  guest: GuestInput;
  payment?: InputMaybe<Payment>;
  promotionId?: InputMaybe<Scalars['String']>;
}>;


export type BookingPaiementMutation = { __typename?: 'Mutation', bookingPaiement?: { __typename?: 'Booking', id?: string | null, status: string, publishableKey?: string | null, accountId?: string | null, paymentIntentSecret?: string | null, depositPaidAmount?: number | null, groupSize: number, bookingDate: string, bookingTime: string, promotionId?: string | null, guest: { __typename?: 'Guest', firstname: string, lastname: string, title?: string | null, mobile: string, mobileCountryCode?: number | null, email: string, postCode?: string | null } } | null };

export type RestaurantReviewsQueryVariables = Exact<{
  restaurantId: Scalars['ID'];
}>;


export type RestaurantReviewsQuery = { __typename?: 'Query', restaurantReviews?: { __typename?: 'RestaurantReview', restaurantCode: string, reviews?: Array<{ __typename: 'CustomerReview', comment?: string | null, createTime?: string | null, name?: string | null, reviewId?: string | null, starRating?: string | null, reviewer?: { __typename?: 'GoogleLocationReviewReviewer', displayName?: string | null, isAnonymous?: boolean | null, profilePhotoUrl?: string | null } | null, reviewReply?: { __typename?: 'GoogleLocationReviewReply', comment?: string | null, updateTime?: string | null } | null } | null> | null } | null };

export type SingleAvailabilitiesQueryVariables = Exact<{
  groupSize: Scalars['Int'];
  realTime: Scalars['Boolean'];
  from: Scalars['String'];
  to?: InputMaybe<Scalars['String']>;
  singleAvailabilitiesId: Scalars['ID'];
}>;


export type SingleAvailabilitiesQuery = { __typename?: 'Query', singleAvailabilities?: Array<{ __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', id?: number | null, groupSize?: number | null, feeAmount?: string | null } | null> | null } | null> | null };

export type BookingQueryVariables = Exact<{
  restaurantId: Scalars['ID'];
  bookingReference: Scalars['ID'];
}>;


export type BookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', bookingDate: string, bookingTime: string, groupSize: number, id?: string | null, guest: { __typename?: 'Guest', email: string, firstname: string, lastname: string, mobile: string, postCode?: string | null } } | null };

export type CitiesByCountrySlugQueryVariables = Exact<{
  countrySlug?: InputMaybe<Scalars['String']>;
}>;


export type CitiesByCountrySlugQuery = { __typename?: 'Query', citiesByCountrySlug?: Array<{ __typename?: 'City', name?: string | null, slug?: string | null } | null> | null };

export type CityQueryVariables = Exact<{
  countrySlug?: InputMaybe<Scalars['String']>;
  citySlug?: InputMaybe<Scalars['String']>;
}>;


export type CityQuery = { __typename?: 'Query', city?: { __typename?: 'City', mainTitle?: string | null, metaDescription?: string | null, metaTitle?: string | null, translatedCountrySlug?: { __typename?: 'TranslatedString', en?: string | null, fr?: string | null } | null, translatedSlug?: { __typename?: 'TranslatedString', en?: string | null, fr?: string | null } | null } | null };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', name?: string | null, slug?: string | null } | null> | null };

export type CountryBaseInformationQueryVariables = Exact<{
  slug: Scalars['String'];
  fallBack?: InputMaybe<Scalars['Boolean']>;
}>;


export type CountryBaseInformationQuery = { __typename?: 'Query', countryBaseInformation?: { __typename?: 'CountryBaseInformation', name?: string | null, code?: string | null, mainTitle?: string | null, contentfulId?: string | null, metaTitle?: string | null, metaDescription?: string | null, slug?: string | null, editorialTopHomepage?: { __typename?: 'EditorialContent', contentfulId?: string | null, subtitle?: string | null, title?: string | null, variant?: string | null, coverImage?: { __typename?: 'FnBPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, slugs?: { __typename?: 'EditorialContentSlugs', en?: string | null, fr?: string | null } | null } | null, inspiration?: Array<{ __typename?: 'EditorialContent', contentfulId?: string | null, subtitle?: string | null, title?: string | null, variant?: string | null, coverImage?: { __typename?: 'FnBPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, slugs?: { __typename?: 'EditorialContentSlugs', en?: string | null, fr?: string | null } | null } | null> | null, coverMedia?: { __typename?: 'FnBPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, nearbyThematics?: Array<{ __typename?: 'NearbyThematic', title?: string | null, thematic?: { __typename?: 'Thematic', name?: string | null, type?: Thematic_Type | null } | null } | null> | null, favoritesRestaurants?: { __typename?: 'FavoritesRestaurants', title?: string | null, restaurants?: Array<{ __typename?: 'Restaurant', averagePrice?: number | null, averageRating?: number | null, bookingWidgetUrl?: string | null, currency?: string | null, facetCodes?: Array<string | null> | null, foodType?: string | null, id: string, city?: string | null, imageUrl?: any | null, hotelCode?: string | null, lat?: number | null, lon?: number | null, partnerId?: string | null, phone?: string | null, phonePrefix?: string | null, name?: string | null, star?: number | null, reviewCount?: number | null, zipCode?: string | null, availabilities?: Array<{ __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null } | null> | null, identifiers?: Array<{ __typename?: 'RestaurantIdentifier', micrositeName?: string | null, system?: System_Type | null } | null> | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null } | null> | null, enrolmentPrograms?: { __typename?: 'RestaurantEnrolmentPrograms', availablePrograms?: Array<string | null> | null, diningOfferParticipation?: { __typename?: 'DiningOfferParticipation', code?: string | null, description?: string | null } | null } | null } | null> | null } | null, seoItems?: Array<{ __typename?: 'CountrySeoItem', title?: string | null, content?: string | null } | null> | null, translatedSlug?: { __typename?: 'TranslatedString', en?: string | null, fr?: string | null } | null } | null };

export type CountryBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  userCity: Scalars['String'];
  userCountry: Scalars['String'];
  date?: InputMaybe<Scalars['String']>;
  groupSize?: InputMaybe<Scalars['Int']>;
}>;


export type CountryBySlugQuery = { __typename?: 'Query', countryBySlug?: { __typename?: 'Country', doesCityExist?: boolean | null, name?: string | null, code?: string | null, mainTitle?: string | null, metaTitle?: string | null, metaDescription?: string | null, nearbyRestaurants?: { __typename?: 'RestaurantSearchResponse', results?: Array<{ __typename?: 'Restaurant', averagePrice?: number | null, averageRating?: number | null, bookingWidgetUrl?: string | null, currency?: string | null, facetCodes?: Array<string | null> | null, foodType?: string | null, id: string, city?: string | null, imageUrl?: any | null, hotelCode?: string | null, lat?: number | null, lon?: number | null, partnerId?: string | null, phone?: string | null, phonePrefix?: string | null, name?: string | null, star?: number | null, reviewCount?: number | null, zipCode?: string | null, availabilities?: Array<{ __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null } | null> | null, identifiers?: Array<{ __typename?: 'RestaurantIdentifier', micrositeName?: string | null, system?: System_Type | null } | null> | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null } | null> | null, enrolmentPrograms?: { __typename?: 'RestaurantEnrolmentPrograms', availablePrograms?: Array<string | null> | null, diningOfferParticipation?: { __typename?: 'DiningOfferParticipation', code?: string | null, description?: string | null } | null } | null } | null> | null } | null, favoritesRestaurants?: { __typename?: 'FavoritesRestaurants', title?: string | null, restaurants?: Array<{ __typename?: 'Restaurant', averagePrice?: number | null, averageRating?: number | null, bookingWidgetUrl?: string | null, currency?: string | null, facetCodes?: Array<string | null> | null, foodType?: string | null, id: string, city?: string | null, imageUrl?: any | null, hotelCode?: string | null, lat?: number | null, lon?: number | null, partnerId?: string | null, phone?: string | null, phonePrefix?: string | null, name?: string | null, star?: number | null, reviewCount?: number | null, zipCode?: string | null, availabilities?: Array<{ __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null } | null> | null, identifiers?: Array<{ __typename?: 'RestaurantIdentifier', micrositeName?: string | null, system?: System_Type | null } | null> | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null } | null> | null, enrolmentPrograms?: { __typename?: 'RestaurantEnrolmentPrograms', availablePrograms?: Array<string | null> | null, diningOfferParticipation?: { __typename?: 'DiningOfferParticipation', code?: string | null, description?: string | null } | null } | null } | null> | null } | null, nearbyThematicRestaurants?: Array<{ __typename?: 'RestaurantSearchResponse', results?: Array<{ __typename?: 'Restaurant', averagePrice?: number | null, averageRating?: number | null, bookingWidgetUrl?: string | null, currency?: string | null, facetCodes?: Array<string | null> | null, foodType?: string | null, id: string, city?: string | null, imageUrl?: any | null, hotelCode?: string | null, lat?: number | null, lon?: number | null, partnerId?: string | null, phone?: string | null, phonePrefix?: string | null, name?: string | null, star?: number | null, reviewCount?: number | null, zipCode?: string | null, availabilities?: Array<{ __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null } | null> | null, identifiers?: Array<{ __typename?: 'RestaurantIdentifier', micrositeName?: string | null, system?: System_Type | null } | null> | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null } | null> | null, enrolmentPrograms?: { __typename?: 'RestaurantEnrolmentPrograms', availablePrograms?: Array<string | null> | null, diningOfferParticipation?: { __typename?: 'DiningOfferParticipation', code?: string | null, description?: string | null } | null } | null } | null> | null, thematic?: { __typename?: 'RestaurantSearchThematic', code?: string | null, title?: string | null, type?: Thematic_Type | null } | null } | null> | null, translatedSlug?: { __typename?: 'TranslatedString', en?: string | null, fr?: string | null } | null, coverMedia?: { __typename?: 'FnBPicture', srcSet?: string | null, src?: string | null, alt?: string | null } | null, nearbyThematics?: Array<{ __typename?: 'NearbyThematic', title?: string | null, thematic?: { __typename?: 'Thematic', name?: string | null, type?: Thematic_Type | null } | null } | null> | null } | null };

export type EditorialContentQueryVariables = Exact<{
  type: Scalars['String'];
  slug: Scalars['String'];
  filteredCities?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type EditorialContentQuery = { __typename?: 'Query', editorialContent?: { __typename?: 'EditorialContent', contentfulId?: string | null, content?: string | null, metaDescription?: string | null, metaTitle?: string | null, pdfUrl?: string | null, subtitle?: string | null, termsAndConditionsTitle?: string | null, termsAndConditionsDescription?: string | null, title?: string | null, variant?: string | null, coverImage?: { __typename?: 'FnBPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, LinkedEditorialContent?: Array<{ __typename?: 'EditorialContent', contentfulId?: string | null, title?: string | null, subtitle?: string | null, variant?: string | null, coverImage?: { __typename?: 'FnBPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, slugs?: { __typename?: 'EditorialContentSlugs', en?: string | null, fr?: string | null } | null } | null> | null, restaurants?: Array<{ __typename?: 'Restaurant', averagePrice?: number | null, averageRating?: number | null, bookingWidgetUrl?: string | null, currency?: string | null, facetCodes?: Array<string | null> | null, foodType?: string | null, id: string, city?: string | null, imageUrl?: any | null, hotelCode?: string | null, lat?: number | null, lon?: number | null, partnerId?: string | null, phone?: string | null, phonePrefix?: string | null, name?: string | null, star?: number | null, reviewCount?: number | null, zipCode?: string | null, availabilities?: Array<{ __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null } | null> | null, identifiers?: Array<{ __typename?: 'RestaurantIdentifier', micrositeName?: string | null, system?: System_Type | null } | null> | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null } | null> | null, enrolmentPrograms?: { __typename?: 'RestaurantEnrolmentPrograms', availablePrograms?: Array<string | null> | null, diningOfferParticipation?: { __typename?: 'DiningOfferParticipation', code?: string | null, description?: string | null } | null } | null } | null> | null, restaurantsCities?: Array<{ __typename?: 'EditorialRestaurantCity', slug?: string | null, name?: string | null } | null> | null, slugs?: { __typename?: 'EditorialContentSlugs', en?: string | null, fr?: string | null } | null } | null };

export type FooterQueryVariables = Exact<{ [key: string]: never; }>;


export type FooterQuery = { __typename?: 'Query', footer?: { __typename?: 'Footer', contentfulId?: string | null, routes?: Array<{ __typename?: 'Route', label?: string | null, internalPageSlug?: string | null, externalUrl?: string | null } | null> | null } | null };

export type InspirationQueryVariables = Exact<{ [key: string]: never; }>;


export type InspirationQuery = { __typename?: 'Query', inspiration?: { __typename?: 'Inspiration', title?: string | null, subtitle?: string | null, metaDescription?: string | null, metaTitle?: string | null } | null };

export type LoyaltyBannersQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type LoyaltyBannersQuery = { __typename?: 'Query', loyaltyBanner?: Array<{ __typename?: 'LoyaltyBanner', contentfulId?: string | null, subtitle?: string | null, title?: string | null, type?: string | null, userStatus?: string | null, program?: string | null, ctaLabel?: string | null, ctaUrl?: string | null, usp?: Array<string | null> | null } | null> | null };

export type NextAvailabilityQueryVariables = Exact<{
  restaurantId: Scalars['ID'];
  groupSize?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  minGuests?: InputMaybe<Scalars['Int']>;
  maxGuests?: InputMaybe<Scalars['Int']>;
  validityPeriods?: InputMaybe<Array<InputMaybe<RestaurantOffersValidityInput>> | InputMaybe<RestaurantOffersValidityInput>>;
}>;


export type NextAvailabilityQuery = { __typename?: 'Query', nextAvailability?: { __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null } | null };

export type PersonalizedPageQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type PersonalizedPageQuery = { __typename?: 'Query', personalizedPage?: { __typename?: 'PersonalizedPage', content?: string | null, contentfulId?: string | null, metaDescription?: string | null, metaTitle?: string | null, slug?: string | null, title?: string | null, translatedSlug?: { __typename?: 'TranslatedString', en?: string | null, fr?: string | null } | null } | null };

export type RestaurantQueryVariables = Exact<{
  restaurantId: Scalars['ID'];
}>;


export type RestaurantQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', accommodateMealCodes?: Array<string | null> | null, accommodateMeals?: Array<string | null> | null, advantages?: Array<string | null> | null, amenities?: Array<string | null> | null, amenityCodes?: Array<string | null> | null, averagePrice?: number | null, averageRating?: number | null, bookingWidgetUrl?: string | null, brandCode?: string | null, carParks?: string | null, catchPhrase?: string | null, city?: string | null, cityMainTitle?: string | null, citySlug?: string | null, country?: string | null, countryCode?: string | null, countrySlug?: string | null, currency?: string | null, currencySymbol?: string | null, externalMenuUrl?: string | null, facebook?: string | null, facetCodes?: Array<string | null> | null, facets?: Array<string | null> | null, defaultFoodType?: string | null, foodType?: string | null, foodTypeCode?: string | null, hotelName?: string | null, hotelCode?: string | null, id: string, instagram?: string | null, lat?: number | null, lon?: number | null, logoUrl?: string | null, mail?: string | null, menuType?: MenuType | null, metaDescription?: string | null, metaTitle?: string | null, name?: string | null, particularity?: string | null, partnerId?: string | null, phone?: string | null, phonePrefix?: string | null, reviewCount?: number | null, star?: number | null, street?: string | null, termsAndConditions?: string | null, timezoneId?: string | null, veryLongDescriptionPart1?: string | null, veryLongDescriptionPart2?: string | null, zipCode?: string | null, zone?: string | null, anecdote?: { __typename?: 'Anecdote', description?: string | null, descriptionTitle?: string | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, generic?: boolean | null, lastUpdate?: string | null, path: string } | null> | null } | null> | null } | null, brunchInsert?: { __typename?: 'RestaurantBrunchInsert', brunchFeatures: Array<string>, days: Array<string>, description?: string | null, title?: string | null, period?: { __typename?: 'RestaurantBrunchPeriod', from?: string | null, to?: string | null } | null } | null, chef?: { __typename?: 'RestaurantChef', description?: string | null, descriptionTitle?: string | null, firstname?: string | null, name?: string | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, generic?: boolean | null, lastUpdate?: string | null, path: string } | null> | null } | null> | null } | null, enrolmentPrograms?: { __typename?: 'RestaurantEnrolmentPrograms', availablePrograms?: Array<string | null> | null, diningOfferParticipation?: { __typename?: 'DiningOfferParticipation', code?: string | null, description?: string | null } | null } | null, exceptionalClosures?: Array<{ __typename?: 'Period', from?: string | null, to?: string | null } | null> | null, identifiers?: Array<{ __typename?: 'RestaurantIdentifier', micrositeName?: string | null, system?: System_Type | null } | null> | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, generic?: boolean | null, lastUpdate?: string | null, path: string } | null> | null } | null> | null, menus?: Array<{ __typename?: 'RestaurantMenu', language?: string | null, name?: string | null, storageUrl?: string | null, urlName?: string | null } | null> | null, nearByRestaurants?: Array<{ __typename?: 'Restaurant', averagePrice?: number | null, averageRating?: number | null, bookingWidgetUrl?: string | null, currency?: string | null, facetCodes?: Array<string | null> | null, foodType?: string | null, id: string, city?: string | null, imageUrl?: any | null, hotelCode?: string | null, lat?: number | null, lon?: number | null, partnerId?: string | null, phone?: string | null, phonePrefix?: string | null, name?: string | null, star?: number | null, reviewCount?: number | null, zipCode?: string | null, availabilities?: Array<{ __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null } | null> | null, identifiers?: Array<{ __typename?: 'RestaurantIdentifier', micrositeName?: string | null, system?: System_Type | null } | null> | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null } | null> | null, enrolmentPrograms?: { __typename?: 'RestaurantEnrolmentPrograms', availablePrograms?: Array<string | null> | null, diningOfferParticipation?: { __typename?: 'DiningOfferParticipation', code?: string | null, description?: string | null } | null } | null } | null> | null, offers?: Array<{ __typename?: 'RestaurantOffers', id?: string | null, name?: string | null, description?: string | null, isAccorPlus?: boolean | null, minGuests?: number | null, maxGuests?: number | null, price?: number | null, chargeAmount?: number | null, requireDeposit?: boolean | null, requireCreditCard?: boolean | null, validityPeriods?: Array<{ __typename?: 'RestaurantOffersValidity', startDate?: string | null, frequency?: Array<Schedule_Days | null> | null, endDate?: string | null } | null> | null, images?: { __typename?: 'RestaurantOffersImage', desktopImage?: { __typename?: 'FnBPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, mobileImage?: { __typename?: 'FnBPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null } | null } | null> | null, schedule?: Array<{ __typename?: 'ScheduleOpenedDay', day: Schedule_Days, openingHours?: Array<{ __typename?: 'OpeningHour', from: string, to: string } | null> | null } | null> | null } | null };

export type RestaurantsByQueryQueryVariables = Exact<{
  city: Scalars['String'];
  country: Scalars['String'];
}>;


export type RestaurantsByQueryQuery = { __typename?: 'Query', restaurantsByQuery?: { __typename?: 'RestaurantSearchResponse', results?: Array<{ __typename?: 'Restaurant', averagePrice?: number | null, averageRating?: number | null, bookingWidgetUrl?: string | null, partnerId?: string | null, city?: string | null, currency?: string | null, defaultFoodType?: string | null, foodType?: string | null, id: string, imageUrl?: any | null, lat?: number | null, lon?: number | null, name?: string | null, reviewCount?: number | null, star?: number | null, zipCode?: string | null, availabilities?: Array<{ __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null } | null> | null, identifiers?: Array<{ __typename?: 'RestaurantIdentifier', micrositeName?: string | null, system?: System_Type | null } | null> | null, medias?: Array<{ __typename?: 'RestaurantMedia', formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string } | null> | null } | null> | null } | null> | null, center: { __typename?: 'GeoLocationPoint', lat: number, lon: number }, box?: { __typename?: 'GeoBox', topLeft: { __typename?: 'GeoLocationPoint', lat: number, lon: number }, bottomRight: { __typename?: 'GeoLocationPoint', lat: number, lon: number } } | null } | null };

export type SearchEditorialContentQueryVariables = Exact<{
  variant?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type SearchEditorialContentQuery = { __typename?: 'Query', searchEditorialContent?: { __typename?: 'SearchEditorialContentResultType', currentPage?: number | null, from?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, size?: number | null, totalPage?: number | null, lastEditorialContent?: { __typename?: 'EditorialContent', contentfulId?: string | null, pdfUrl?: string | null, slug?: string | null, subtitle?: string | null, title?: string | null, variant?: string | null, coverImage?: { __typename?: 'FnBPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null } | null, results?: Array<{ __typename?: 'EditorialContent', contentfulId?: string | null, content?: string | null, metaDescription?: string | null, metaTitle?: string | null, pdfUrl?: string | null, subtitle?: string | null, termsAndConditionsTitle?: string | null, termsAndConditionsDescription?: string | null, title?: string | null, variant?: string | null, slug?: string | null, coverImage?: { __typename?: 'FnBPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, restaurants?: Array<{ __typename?: 'Restaurant', averagePrice?: number | null, averageRating?: number | null, bookingWidgetUrl?: string | null, currency?: string | null, facetCodes?: Array<string | null> | null, foodType?: string | null, id: string, city?: string | null, imageUrl?: any | null, hotelCode?: string | null, lat?: number | null, lon?: number | null, partnerId?: string | null, phone?: string | null, phonePrefix?: string | null, name?: string | null, star?: number | null, reviewCount?: number | null, zipCode?: string | null, availabilities?: Array<{ __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null } | null> | null, identifiers?: Array<{ __typename?: 'RestaurantIdentifier', micrositeName?: string | null, system?: System_Type | null } | null> | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null } | null> | null, enrolmentPrograms?: { __typename?: 'RestaurantEnrolmentPrograms', availablePrograms?: Array<string | null> | null, diningOfferParticipation?: { __typename?: 'DiningOfferParticipation', code?: string | null, description?: string | null } | null } | null } | null> | null, slugs?: { __typename?: 'EditorialContentSlugs', en?: string | null, fr?: string | null } | null } | null> | null } | null };

export type SearchRestaurantsQueryVariables = Exact<{
  poiQuery?: InputMaybe<Scalars['String']>;
  citySlug?: InputMaybe<Scalars['String']>;
  countrySlug?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  groupSize?: InputMaybe<Scalars['Int']>;
  searchFilters?: InputMaybe<SearchFilterInput>;
  geoQuery?: InputMaybe<GeoQueryInput>;
}>;


export type SearchRestaurantsQuery = { __typename?: 'Query', searchRestaurants?: { __typename?: 'RestaurantSearchResponse', radius?: number | null, center: { __typename?: 'GeoLocationPoint', lat: number, lon: number }, box?: { __typename?: 'GeoBox', bottomLeft: { __typename?: 'GeoLocationPoint', lat: number, lon: number }, bottomRight: { __typename?: 'GeoLocationPoint', lat: number, lon: number }, topLeft: { __typename?: 'GeoLocationPoint', lat: number, lon: number }, topRight: { __typename?: 'GeoLocationPoint', lat: number, lon: number } } | null, filters?: { __typename?: 'SearchFilterResponse', available?: number | null, userMinPrice?: number | null, userMaxPrice?: number | null, globalMinPrice?: number | null, globalMaxPrice?: number | null, currency?: string | null, THEMATIC?: Array<{ __typename?: 'FilterResponse', code?: string | null, label?: string | null, count?: number | null } | null> | null, STYLE_OF_FOOD?: Array<{ __typename?: 'FilterResponse', code?: string | null, label?: string | null, count?: number | null } | null> | null, FOOD_PREFERENCES?: Array<{ __typename?: 'FilterResponse', code?: string | null, label?: string | null, count?: number | null } | null> | null, AVERAGE_RATING?: Array<{ __typename?: 'FilterResponse', code?: string | null, label?: string | null, count?: number | null, selected?: boolean | null } | null> | null, OFFER_AND_LOYALTY?: Array<{ __typename?: 'FilterResponse', code?: string | null, label?: string | null, count?: number | null, selected?: boolean | null } | null> | null } | null, results?: Array<{ __typename?: 'Restaurant', averagePrice?: number | null, averageRating?: number | null, bookingWidgetUrl?: string | null, currency?: string | null, facetCodes?: Array<string | null> | null, foodType?: string | null, id: string, city?: string | null, imageUrl?: any | null, hotelCode?: string | null, lat?: number | null, lon?: number | null, partnerId?: string | null, phone?: string | null, phonePrefix?: string | null, name?: string | null, star?: number | null, reviewCount?: number | null, zipCode?: string | null, availabilities?: Array<{ __typename?: 'AvailabilitySlot', date: string, groupSize?: number | null, isStandard?: boolean | null, slot: string, standardAvailabilityFeeAmount?: string | null, requireCreditCard?: boolean | null, offers?: Array<{ __typename?: 'Offer', feeAmount?: string | null, groupSize?: number | null, id?: number | null } | null> | null } | null> | null, identifiers?: Array<{ __typename?: 'RestaurantIdentifier', micrositeName?: string | null, system?: System_Type | null } | null> | null, medias?: Array<{ __typename?: 'RestaurantMedia', type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null } | null> | null, enrolmentPrograms?: { __typename?: 'RestaurantEnrolmentPrograms', availablePrograms?: Array<string | null> | null, diningOfferParticipation?: { __typename?: 'DiningOfferParticipation', code?: string | null, description?: string | null } | null } | null } | null> | null, statistics?: { __typename?: 'RestaurantSearchStats', count?: number | null } | null, thematic?: { __typename?: 'RestaurantSearchThematic', title?: string | null, code?: string | null, type?: Thematic_Type | null } | null } | null };

export type SitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type SitemapQuery = { __typename?: 'Query', sitemap?: { __typename?: 'Sitemap', cities?: Array<{ __typename?: 'City', countryCode?: string | null, countrySlug?: string | null, mainTitle?: string | null, name?: string | null, slug?: string | null, updatedAt?: string | null, translatedCountrySlug?: { __typename?: 'TranslatedString', en?: string | null, fr?: string | null } | null, translatedSlug?: { __typename?: 'TranslatedString', en?: string | null, fr?: string | null } | null } | null> | null, countries?: Array<{ __typename?: 'CountryBaseInformation', name?: string | null, code?: string | null, slug?: string | null, updatedAt?: string | null, translatedSlug?: { __typename?: 'TranslatedString', en?: string | null, fr?: string | null } | null } | null> | null, restaurants?: Array<{ __typename?: 'Restaurant', code?: string | null, countryCode?: string | null, id: string, name?: string | null, updatedAt?: string | null } | null> | null, personalizedPages?: Array<{ __typename?: 'PersonalizedPage', slug?: string | null, title?: string | null, updatedAt?: string | null, translatedSlug?: { __typename?: 'TranslatedString', en?: string | null, fr?: string | null } | null } | null> | null, inspiration?: { __typename?: 'Inspiration', title?: string | null } | null, editorialContents?: Array<{ __typename?: 'EditorialContent', title?: string | null, slug?: string | null, variant?: string | null } | null> | null } | null };

export type GetSuggestionsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type GetSuggestionsQuery = { __typename?: 'Query', getSuggestions?: Array<{ __typename?: 'CitySuggestion', citySlug?: string | null, countrySlug?: string | null, description?: string | null, type?: string | null } | { __typename?: 'CountrySuggestion', countrySlug?: string | null, description?: string | null, type?: string | null } | { __typename?: 'PoiSuggestion', description?: string | null, type?: string | null } | { __typename?: 'RestaurantSuggestion', code?: string | null, city?: string | null, description?: string | null, facet?: string | null, restaurantCode?: string | null, type?: string | null, foodType?: string | null, media?: { __typename?: 'RestaurantMedia', formats?: Array<{ __typename?: 'AccorMediaFormat', path: string, format?: string | null } | null> | null } | null } | null> | null };

// Generated on 2025-05-26T07:20:39+00:00
